import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminGlobalSearchVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const searchGlobal = createAsyncThunk<AdminGlobalSearchVM, { query: string }, { extra: Partial<Dependencies> }>(
  "admin/searchGlobal",
  async ({ query }, { extra: { adminRepository } }) => {
    return adminRepository!.globalSearch(query);
  },
);
